
import { useRoute } from "vue-router";
import { defineComponent} from "vue";
export default defineComponent({
	props: {
		diallel: {
			type: Boolean,
			default: false,
		},
	},
	setup(props: any, { slots }: any) {
		const route = useRoute();
		const Diallel = () => {
			return (
				<div class="pages-layout__diallel">
					<div class="sidebar">{slots.sidebar && slots.sidebar()}</div>
					<div class="main">{slots.sidebar && slots.sidebar()}</div>
				</div>
			);
		};
		const NoDiallel = () => {
			return <>{slots.default && slots.default()}</>;
		};
		const Handle = () => {
			return <div class="handle">{slots.handle && slots.handle()}</div>;
		};
		return () => {
			return (
				<div class={[slots.handle ? "handle-spacing" : "", "pages-layout"]}>
					{props.diallel ? <Diallel></Diallel> : <NoDiallel></NoDiallel>}
					{slots.handle ? <Handle></Handle> : ""}
				</div>
			);
		};
	},
});
